import { Avatar as AvatarAntd, Typography } from 'antd';
import styled from 'styled-components';
import { NeutralColors } from 'theme';

const ProfileButtonWrapper = styled.div`
  height: 64px;
  margin: 16px;
  display: flex;
  padding: 12px;

  align-items: center;
  justify-content: space-between;

  color: ${NeutralColors[60]};
  background-color: ${NeutralColors[10]};

  border-radius: 12px;
  :hover {
    cursor: pointer;
  }

  .fms-space-item {
    display: flex;
  }
`;

const TitleName = styled(Typography.Title)`
  margin-bottom: 0 !important;
`;

const Avatar = styled(AvatarAntd)`
  background-color: ${NeutralColors[90]};
  color: ${NeutralColors[0]};
`;

const NotificationSlot = styled.div`
  display: flex;
  align-items: center;
`;

export { Avatar, NotificationSlot, ProfileButtonWrapper, TitleName };
